import React from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
// import ContentCopy from "@material-ui/icons/ContentCopy";
import Store from "@material-ui/icons/Store";
import LocalShipping from "@material-ui/icons/LocalShipping";
import Person from "@material-ui/icons/Person";
// import InfoOutline from "@material-ui/icons/InfoOutline";
//import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import Today from "@material-ui/icons/Today";
import SentimentSatisfied from "@material-ui/icons/SentimentSatisfiedAlt";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
//import Danger from "components/Typography/Danger.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import FormControl from "./CustomFormControl";
import YearFormControl from "./YearFormControl";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import { monthData, yearData } from "../../variables/data";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { dev, prod } from "../../config/config";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      selectedYear: "2018",
      selectedMonth: "0",
      activeUser: 0,
      trucker: 0,
      agent: 0,
      general: 0,
      landlords: 0,
      freelancers: 0,
      isMounted: false,
      time: "Today",
      config: prod
    };

    this.unsubToday = null;
    this.getDataWithDate = this.getDataWithDate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
  }
  handleChange = (event, value) => {
    this.setState({ value });
  };
  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  handleYearChange = year => {
    this.setState(
      {
        selectedYear: year
      },
      () => {
        if (this.state.selectedMonth !== "0") this.getDataCollection();
      }
    );
  };

  handleDateChange(index) {
    this.setState(
      {
        time:
          monthData.data[parseInt(index, 10)] + "/" + this.state.selectedYear,
        selectedMonth: index
      },
      () => {
        index === "0" ? this.getDataWithDate() : this.getDataCollection();
      }
    );
  }

  getDataCollection() {
    //console.log(this.state.config.DB_USERS);
    this.unsubToday();
    //var dateObj = new Date();
    //var year = dateObj.getUTCFullYear();
    var newdate = this.state.selectedYear + "/" + this.state.selectedMonth;
    //console.log(this.state.config.DB_USERS, "new date => ", newdate);
    firebase
      .firestore()
      .collection(this.state.config.DB_USERS + "/" + newdate)
      .get()
      .then(querySnapshot => {
        var activeUsers = 0;
        var trucker = 0;
        var general = 0;
        var landlords = 0;
        var agent = 0;
        var freelancers = 0;
        querySnapshot.forEach(doc => {
          activeUsers = activeUsers + this.getActiveUsers(doc.data());
          general = general + this.getGeneralFiles(doc.data());
          trucker = trucker + this.getTruckerFiles(doc.data());
          landlords = landlords + this.getLandlordFiles(doc.data());
          agent = agent + this.getAgentFiles(doc.data());
          freelancers = freelancers + this.getFreelancersFiles(doc.data());
        });
        this.setState({
          activeUser: activeUsers,
          trucker: trucker,
          landlords: landlords,
          agent: agent,
          general: general,
          freelancers: freelancers
        });
      })
      .catch(error => {
        //console.log(error.message);
      });
  }

  getActiveUsers(data) {
    if (data.activeUsers) {
      return data.activeUsers;
    }
    return 0;
  }
  getAgentFiles = data => {
    if (data.agent) {
      return data.agent;
    }
    return 0;
  };

  getFreelancersFiles = data => {
    if (data.freelancers) {
      return data.freelancers;
    }
    return 0;
  };
  getTruckerFiles = data => {
    if (data.trucker) {
      return data.trucker;
    }
    return 0;
  };

  getGeneralFiles = data => {
    if (data.general) {
      return data.general;
    }
    return 0;
  };

  getLandlordFiles = data => {
    if (data.landlords) {
      return data.landlords;
    }
    return 0;
  };

  getDataWithDate() {
    var dateObj = new Date();
    var locale = moment(dateObj);
    var canada = locale.clone().tz("Canada/Central");
    var month = canada.month() + 1; //months from 1-12
    var day = canada.date();
    var year = canada.year();

    var newdate = year + "/" + month + "/" + day;
    //console.log(this.state.config.DB_USERS, "new date => ", newdate);
    this.unsubToday = firebase
      .firestore()
      .collection(this.state.config.DB_USERS)
      .doc(newdate)
      .onSnapshot(doc => {
        if (this.state.isMounted) {
          var activeUsers = 0;
          var trucker = 0;
          var general = 0;
          var landlords = 0;
          var freelancers = 0;
          var agent = 0;
          if (doc.exists) {
            if (doc.data().activeUsers) {
              activeUsers = doc.data().activeUsers;
            }
            if (doc.data().trucker) {
              trucker = doc.data().trucker;
            }
            if (doc.data().agent) {
              agent = doc.data().agent;
            }
            if (doc.data().general) {
              general = doc.data().general;
            }
            if (doc.data().landlords) {
              landlords = doc.data().landlords;
            }
            if (doc.data().freelancers) {
              freelancers = doc.data().freelancers;
            }
          }
          this.setState({
            activeUser: activeUsers,
            trucker: trucker,
            landlords: landlords,
            agent: agent,
            general: general,
            freelancers: freelancers
          });
        }
      });
  }
  componentDidMount() {
    if (
      firebase.auth().currentUser &&
      firebase.auth().currentUser.email === "dev_admin@proledgers.com"
    ) {
      this.setState(
        {
          config: dev
        },
        () => {
          this.getDataWithDate(0);
        }
      );
    } else {
      this.setState(
        {
          isMounted: true
        },
        () => {
          this.getDataWithDate(0);
        }
      );
    }
  }

  componentWillUnmount() {
    // if (this.unsubToday) {
    //   this.unsubToday();
    // }
    this.setState({
      isMounted: false
    });
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <Person />
                </CardIcon>
                <p className={classes.cardCategory}>Active Users</p>
                <h3 className={classes.cardTitle}>
                  {this.state.activeUser} <small>Users</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  {this.state.time}
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3} />
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="rose" stats icon>
                <CardIcon color="rose">
                  <Today />
                </CardIcon>
                <p className={classes.cardCategory}>Select Date</p>
              </CardHeader>
              <CardBody>
                <FormControl
                  fullWidth
                  handleDateChange={this.handleDateChange}
                />
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="rose" stats icon>
                <CardIcon color="rose">
                  <Today />
                </CardIcon>
                <p className={classes.cardCategory}>Select Year</p>
              </CardHeader>
              <CardBody>
                <YearFormControl
                  data={yearData}
                  fullWidth
                  handleDateChange={this.handleYearChange}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <LocalShipping />
                </CardIcon>
                <p className={classes.cardCategory}>Trucker</p>
                <h3 className={classes.cardTitle}>{this.state.trucker}</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  {this.state.time}
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Store />
                </CardIcon>
                <p className={classes.cardCategory}>Agent</p>
                <h3 className={classes.cardTitle}>{this.state.agent}</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  {this.state.time}
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <Icon>info_outline</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Landlords</p>
                <h3 className={classes.cardTitle}>{this.state.landlords}</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  {this.state.time}
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <i className="fab fa-twitter" />
                </CardIcon>
                <p className={classes.cardCategory}>Small Business</p>
                <h3 className={classes.cardTitle}>{this.state.general}</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  {this.state.time}
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <SentimentSatisfied />
                </CardIcon>
                <p className={classes.cardCategory}>Freelancers</p>
                <h3 className={classes.cardTitle}>{this.state.freelancers}</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  {this.state.time}
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx